import { put } from 'redux-saga/effects';
import * as actions from './../actions';
import * as paths from './../../ClientAPI/paths';
import Utils from '../../utils/Utils';

export function* getMarketingOfferSaga(action) {
  const axios = yield Utils.getAxiosWithToken();
  try {
    let data = {
      productId: action.productId ? action.productId : 1,
    };

    if (action.moid) {
      data.moid = action.moid;
    }

    const response = yield axios({
      url: paths.marketing_offer.GET,
      method: 'post',
      data: data,
    });

    if (!response) {
      throw new Error('[ERROR] Send Email response is empty!');
    }

    if (typeof response['result'] === 'undefined') {
      throw new Error("[ERROR] Send Email response has no 'result' property");
    }

    if (Array.isArray(response['result']) && response['result'].length === 0) {
      yield put(actions.setMarketingOffer(false));
      return;
    }
    if (data.moid) {
      yield put(actions.setMarketingOffer({ ...response.result, wanted_moid: data.moid }));
    } else {
      yield put(actions.setMarketingOffer(response.result));
    }
  } catch (error) {
    console.log(error);
    return;
  }
}
